import { CircularProgress } from '@mui/material';
import React from 'react';
import styled from 'styled-components';


const CmsCircularProgress = () => {

    const CircularDiv = styled.div`
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
`;
  return (
    <CircularDiv className="text-center my-3">
         <CircularProgress size={30} />
        </CircularDiv> 
  );
};

export default CmsCircularProgress;


